import styled, { css } from 'styled-components';
import {
  FontSizes,
  HeaderSecondary,
  TextBody,
} from '../typography/typography.styles';
import {
  GeneralStyles,
  TextItemStyles,
} from '../../models/generic-info-block/generic-info-block';
import { InputMessageContainer } from '../input-message/input-message.styles';

export const MainBlockContainer = styled.div<{ $isEmpty: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  ${({ $isEmpty }) =>
    $isEmpty &&
    css`
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 100%;
    `}

  @media screen and (max-width: 650px) {
    gap: 0.8rem;
  }

  ${InputMessageContainer} {
    margin-top: 0;
  }
`;

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  background-color: ${({ theme }) => theme.colors.namedColors.white};
  border-radius: 1.2rem;
  border: 1px solid ${({ theme }) => theme.colors.baseColors.grey25};
  padding: 1.6rem;
`;

export const SectionTitle = styled.p`
  color: ${({ theme }) => theme.colors.baseColors.gray150};
  font-size: ${FontSizes.medium};
  font-style: normal;
  font-weight: 700;
  line-height: 2.2rem;
  letter-spacing: 0.5px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media screen and (max-width: 650px) {
    gap: 16px;
  }
`;

interface TextBlockProps {
  $generalStyle?: 'li';
  $isOnlyNotice?: boolean;
}

export const TextBlock = styled.div<TextBlockProps>`
  ${({ $isOnlyNotice }) =>
    $isOnlyNotice
      ? css`
          margin-bottom: -12px;
          @media screen and (min-width: 768px) {
            margin-bottom: -8px;
          }
        `
      : css`
          display: grid;
          gap: 0.4rem;
        `}
`;

interface TextItemsContainerProps {
  $generalStyle: GeneralStyles | undefined;
}

export const TextItemsContainer = styled.div<TextItemsContainerProps>`
  ${({ $generalStyle }) => {
    if ($generalStyle === 'li') {
      return css`
        position: relative;
        padding-left: 15px;
        margin-left: 10px;
        &::before {
          position: absolute;
          top: 7px;
          left: 0;
          content: '•';
          color: currentColor;
          font-size: 30px;
          line-height: 0;
        }
      `;
    }

    if ($generalStyle === 'withImage') {
      return css`
        padding-left: 25px;
        position: relative;

        &:before {
          display: block;
          content: '';
          width: 3px;
          height: 3px;
          background: ${({ theme }) => theme.colors.baseColors.grey150};
          position: absolute;
          top: 9px;
          left: 8px;
          border-radius: 50%;
        }
      `;
    }
  }}
`;

interface TextItemProps {
  $style: TextItemStyles;
}

const getTextItemStyles = (style: TextItemStyles) => {
  if (style === 'green') {
    return css`
      color: #39a55b;
    `;
  }
  if (style === 'red') {
    return css`
      color: #ba2243;
    `;
  }
  if (style === 'default') {
    return css`
      color: #2c363f;
    `;
  }
  if (style === 'bold') {
    return css`
      font-size: ${FontSizes.medium};
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
      letter-spacing: 0.5px;
    `;
  }
};

export const TextItem = styled(HeaderSecondary).attrs({
  as: 'span',
  $size: 'medium',
})<TextItemProps>`
  font-weight: 500;
  font-size: ${FontSizes.normal};
  margin-right: 5px;
  ${({ $style }) => getTextItemStyles($style)}
`;

export const TextImage = styled.img`
  width: 2rem;
  height: 2rem;
`;

export const TextNotice = styled(TextBody)``;
